import { render, staticRenderFns } from "./CartSuggested.vue?vue&type=template&id=37caa5b2&scoped=true"
import script from "./CartSuggested.vue?vue&type=script&lang=js"
export * from "./CartSuggested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37caa5b2",
  null
  
)

export default component.exports